/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Utils
import { useTranslation } from "react-i18next";

// Components
import { List, ListItem, Typography } from "@mui/material";

import Link from "@mui/material/Link";
import Box from "@mui/material/Box";

function HelpModalScreen() {
  const { t } = useTranslation(["help", "community"]);

  return (
    <Box sx={{ overflow: "scroll", overflowX: "hidden", maxHeight: "85vh", padding: "1rem" }}>
      <Typography variant="h1" mb={2}>
        {t("community.configuration.title")}
      </Typography>
      <hr />
      {/*---*/}
      <Typography variant="h3" mt={4} ml={2}>
        {t("community.configuration.market_title")}
      </Typography>
      <Typography variant="h4" mt={2} ml={4}>
        {t("community.configuration.lem_trading_fee")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("community.configuration.lem_trading_fee_desc")}
        </Box>
      </Typography>
      <Typography variant="h4" mt={2} ml={4}>
        {t("community.configuration.transaction_adjustment_tolerance")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("community.configuration.transaction_adjustment_tolerance_desc")}
        </Box>
      </Typography>
      <Typography variant="h4" mt={4} ml={4}>
        {t("community.configuration.pricing_method_title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("community.configuration.pricing_method_intro")}
        </Box>
      </Typography>
      <Box ml={6}>
        <List component="ul">
          <ListItem component="li" divider>
            <Typography variant="text" fontSize="1rem" mt={2}>
              <Typography component="span" variant="text" fontWeight={700} fontSize="1rem">
                {t("community.configuration.methods.imr.title")}
              </Typography>{" "}
              {t("community.configuration.methods.imr.desc")}
            </Typography>
          </ListItem>
          <ListItem component="li" divider>
            <Typography variant="text" fontSize="1rem" mt={2}>
              <Typography component="span" variant="text" fontWeight={700} fontSize="1rem">
                {t("community.configuration.methods.sdr.title")}
              </Typography>{" "}
              {t("community.configuration.methods.sdr.desc")}
            </Typography>
          </ListItem>
          <ListItem component="li" divider>
            <Typography variant="text" fontSize="1rem" mt={2}>
              <Typography component="span" variant="text" fontWeight={700} fontSize="1rem">
                {t("community.configuration.methods.pdpp.title")}
              </Typography>{" "}
              {t("community.configuration.methods.pdpp.desc")}
            </Typography>
          </ListItem>
          <ListItem component="li" divider>
            <Typography variant="text" fontSize="1rem" mt={2}>
              <Typography component="span" variant="text" fontWeight={700} fontSize="1rem">
                {t("community.configuration.methods.fixed.title")}
              </Typography>{" "}
              {t("community.configuration.methods.fixed.desc")}
            </Typography>
          </ListItem>
        </List>
      </Box>
      <Box ml={4} mt={4}>
        <Typography variant="text" fontSize="1rem">
          {t("community.configuration.more_info_prefix")}{" "}
          <Link href="https://ieeexplore.ieee.org/abstract/document/10161899" target="_blank">
            {t("community.configuration.link_text")}
          </Link>
          .
          <br />
          <Typography component="span" variant="text" fontWeight={700} fontSize="1rem">
            {t("community.configuration.note_label")}
          </Typography>{" "}
          {t("community.configuration.note_text")}
        </Typography>
      </Box>
    </Box>
  );
}

export default HelpModalScreen;
